import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { ComparatorService } from '@adgate/common/services/comparator-service';
import { DialogService } from '@adgate/common/services/dialog-service';
import { ObjectDescPipe } from '@adgate/common/pipes/object-desc-pipe';
import { BaseObject } from '@adgate/common/types/base-object.type';
import { CustomValidators } from '@adgate/common/validators/custom-validators.validator';
import { CommonObjectService } from '@adgate/common/services/common-object-service';
import { CommercialType } from '@adgate/common/types/commercial-type.type';
import { RESTApplicationResponse } from '@adgate/common/types/rest-application-response.type';
import { ProductionVersion } from '@adgate/modules/production/types/production-version.type';

@Component({
  selector: 'app-production-version-edit-dialog-component',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    ObjectDescPipe
  ],
  templateUrl: './production-version-edit-dialog-component.html',
  styleUrl: './production-version-edit-dialog-component.scss',
})
export class ProductionVersionEditDialogComponent implements OnInit
{
  private dialogRef: MatDialogRef<ProductionVersionEditDialogComponent> = inject(MatDialogRef<ProductionVersionEditDialogComponent>);
  private fb: FormBuilder = inject(FormBuilder);
  private dialogService: DialogService = inject(DialogService);
  private commonObjectService: CommonObjectService = inject(CommonObjectService);

  public data: ProductionVersion = inject(MAT_DIALOG_DATA, { optional: false });
  public comparatorService: ComparatorService = inject(ComparatorService);

  versionForm: FormGroup;
  versionTypes: BaseObject[] = [];

  constructor()
  {
    this.versionForm = this.fb.group({
      type: ['', Validators.required],
      name: ['', [Validators.required, CustomValidators.invalidCharactersValidator()]],
      notes: ['']
    });
  }

  ngOnInit(): void
  {
    this.dialogService.showProgress();

    this.commonObjectService.getCommercialTypes(CommercialType.USAGE_PRODUCTIONVERSION).subscribe({
      next: (response: RESTApplicationResponse) => {
        this.versionTypes = response.data;

        if (this.data.id !== -1) {
          this.versionForm.get('type')?.setValue(this.data.type);
          this.versionForm.get('name')?.setValue(this.data.name);
          this.versionForm.get('notes')?.setValue(this.data.notes);
        }

        this.dialogService.hideProgress();
      },
      error: (err: Error) => {
        this.dialogService.openErrorDialog(err.message);
      }
    });
  }

  onCancel(): void
  {
    this.dialogRef.close(null);
  }

  onSubmit(): void
  {
    if (this.versionForm.valid) {
      this.data.type = this.versionForm.get('type')?.value;
      this.data.name = this.versionForm.get('name')?.value;
      this.data.notes = this.versionForm.get('notes')?.value;

      this.dialogRef.close(this.data);
    }
  }
}
